import React from "react";
import { Route, Routes } from "react-router-dom";
import { MathJaxContext } from "better-react-mathjax";
import Layout from "./components/Layout";
import PrivateRoute from "./components/privateRoute/PrivateRoute";
import Login from "./components/Login";
import NotFound from "./components/NotFound";
import LoadTest from "./components/LoadTest";
import DistrictTemplate from "./segments/DistrictTemplate";
import Home from "./segments/Home";
import ManageEprContent from "./segments/ManageEprContent";

/**
 * Routing for EPR
 * @name App
 * @return {JSX.Element}
 */
const App = () => {
    const config = {
        loader: { load: ["input/tex", "output/svg"] },
        tex: {
            inlineMath: [
                ["$", "$"],
                ["\\(", "\\)"]
            ]
        }
    };

    return (
        <MathJaxContext config={config} src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js">
            <Routes>
                {/* Protected Routes */}
                <Route path="/" element={<PrivateRoute />}>
                    {/* Main Pages */}
                    <Route index element={<Home />} />
                    <Route path="home" element={<Home />} />
                    <Route path="manage-epr-content" element={<ManageEprContent />} />
                    <Route path="district-template" element={<DistrictTemplate />} />

                    {/* Home Templates */}
                    <Route path="home/template" element={<Home />} />
                    <Route path="home/template/define" element={<Home />} />
                    <Route path="home/sles" element={<Home />} />

                    {/* Teacher Summary */}
                    <Route path="home/summary" element={<Home />} />

                    {/* Roster Routes */}
                    <Route path="home/summary/roster">
                        <Route index element={<Home />} />
                        <Route path=":gradingProfileId" element={<Home />} />
                        <Route path=":gradingProfileId/groups" element={<Home />} />
                        <Route path="groups" element={<Home />} />
                    </Route>

                    {/* Share Routes */}
                    <Route path="home/summary/share">
                        <Route index element={<Home />} />
                        <Route path=":gradingProfileId" element={<Home />} />
                        <Route path=":gradingProfileId/:homeroomGroupId" element={<Home />} />
                    </Route>

                    {/* Input Rating Routes */}
                    <Route path="home/summary/input-ratings">
                        <Route index element={<Home />} />
                        <Route path=":gradingProfileId" element={<Home />} />
                        <Route path="groups" element={<Home />} />
                    </Route>

                    {/* Dev LoadTest */}
                    {process.env.NODE_ENV !== "production" && (
                        <Route path="loadtest/:userName" element={<LoadTest />} />
                    )}
                </Route>

                {/* Public / Dev Routes */}
                {process.env.NODE_ENV !== "production" && (
                    <>
                        <Route path="/backdoor" element={<Login />} />
                        <Route path="/layout" element={<Layout />} />
                        <Route path="/loadtest" element={<NotFound />} />
                    </>
                )}

                {/* Not Found Fallback */}
                <Route path="/notFound" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </MathJaxContext>
    );
};

export default App;
